import { UserMenu, Logout, RefreshIconButton } from 'react-admin';
import { AppBar, Box, Toolbar } from '@mui/material';
import { TenantSelector } from './TenantSelector';

const MyUserMenu = (props: any) => {
  // Filter out props that shouldn't be passed to DOM elements
  const { dashboard, ...sanitizedProps } = props;
  
  return (
    <UserMenu {...sanitizedProps}>
      <Logout />
    </UserMenu>
  );
};

// This creates a custom AppBar without the sidebar toggle button
export const CustomAppBar = (props: any) => {
  // Filter out props that shouldn't be passed to DOM elements
  const { dashboard, ...sanitizedProps } = props;
  
  return (
    <AppBar 
      color="primary"
      elevation={0}
      sx={{
        backgroundColor: 'transparent',
        color: '#1C5195',
        position: 'relative',
        width: '100%',
        '&.MuiPaper-root': {
          borderBottom: 'none',
          boxShadow: 'none',
        },
      }}
    >
      <Toolbar sx={{ width: '100%', display: 'flex', justifyContent: 'space-between' }}>
        {/* Left side - empty for now */}
        <Box>
          {/* Can add logo or other elements here if needed */}
        </Box>
        
        {/* Right side - contains tenant selector, refresh icon and user menu */}
        <Box 
          className="ext-app-bar"
          sx={{ 
            display: 'flex', 
            alignItems: 'center',
            gap: '16px',
          }}
        >
          <TenantSelector />
          
          <Box 
            className="ext-horizontal-separator"
            sx={{ 
              width: '1px',
              height: '24px',
              backgroundColor: '#C8D4D2',
              border: '1px solid #C8D4D2',
            }} 
          />
          
          <RefreshIconButton />
          
          <Box 
            className="ext-horizontal-separator"
            sx={{ 
              width: '1px',
              height: '24px',
              backgroundColor: '#C8D4D2',
              border: '1px solid #C8D4D2',
            }} 
          />
          
          <MyUserMenu {...sanitizedProps} />
        </Box>
      </Toolbar>
    </AppBar>
  );
};